import React from "react";
import PropTypes from "prop-types";
import { Field } from "redux-form";
import { properCase } from "LIB/formatters/text";
import { toOptions } from "LIB/forms";
import { Select } from "MODULES/shared/components/Forms";
import { VENDOR_TERMS } from "MODULES/companies/constants";

export function PaymentTerms({ paymentTerms }) {
  return <span>{properCase(paymentTerms)}</span>;
}

PaymentTerms.propTypes = {
  paymentTerms: PropTypes.string
};

export function PaymentTermsField({ fieldName, label }) {
  return (
    <Field
      name={fieldName}
      component={Select}
      label={label}
      options={toOptions(VENDOR_TERMS)}
    />
  );
}

PaymentTermsField.propTypes = {
  fieldName: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired
};



// WEBPACK FOOTER //
// ./app/modules/companies/shared/components/PaymentTerms.jsx